import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { isTokenExpired } from "../utils/jwt";

const ProtectedRoute = ({ allowedRoles, children }) => {
  const location = useLocation();
  const { accessToken, isAuthenticated, user, loading } = useSelector(
    (state) => state.auth,
  );

  if (loading) {
    return null;
  }

  if (!isAuthenticated || !accessToken || isTokenExpired(accessToken)) {
    return <Navigate to="/sign-in" replace />;
  }

  if (allowedRoles) {
    const userRole = user?.rol?.trim();

    if (!allowedRoles.includes(userRole)) {
      return <Navigate to="/sign-in" replace />;
    }
  }

  return children ? children : <Outlet />;
};

export default ProtectedRoute;
